import * as React from "react";
import * as documentService from "../../models/services/documentService";
import { Base } from "ui/Scripts/source/framework/base";
import { customHistory } from "../../framework/customHistory";
import { Translations } from "ui/Scripts/source/models/translations";
import { RouteComponentProps } from "react-router";
import { EditPageHeader } from "../app/header";
import { IDocumentViewItem } from "../../models/document/documentViewItem";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { AppUtils } from "../../framework/appUtils";
import { Footer } from "../app/footer";

//DocumentView
export interface IDocumentViewOwnProps {
}

export interface IDocumentViewStateProps {
    item: IDocumentViewItem;
    returnUrl: string;
}

export interface IDocumentViewDispatchProps {
    loadDocumentView: (id: string, companyId: string) => void;
    resetDocumentView: () => void;
}

export interface IDocumentViewPathProps {
    documentVersionId: string;
    companyId: string;
}

type DocumentViewProp = IDocumentViewOwnProps & IDocumentViewStateProps & IDocumentViewDispatchProps & RouteComponentProps<IDocumentViewPathProps>;

interface IDocumentViewState {
    id: string;
}

export class DocumentView extends React.Component<DocumentViewProp, IDocumentViewState> {
    constructor(props: DocumentViewProp) {
        super(props);
        this.state = { id: !Base.isNullOrUndefined(props.item) ? props.item.id : null };
    }

    componentDidMount(): void {
        const props = this.props;
        props.loadDocumentView(props.match.params.documentVersionId, props.match.params.companyId);
    }

    static getDerivedStateFromProps(nextProps: DocumentViewProp, prevState: IDocumentViewState): IDocumentViewState {
        if (!Base.isNullOrUndefined(nextProps.item) && nextProps.item.id !== prevState.id) {
            return { id: nextProps.item.id };
        } else {
            return null;
        }
    }

    componentWillUnmount(): void {
        this.props.resetDocumentView();
    }

    handleDownload = async () => {
        const item = this.props.item;
        const fileName = await AppUtils.callService(() => documentService.downloadDocument(item.directoryItemId, item.companyId));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.DocumentParameterDownloaded, fileName));
    };

    handleBackClick = () => {
        customHistory.push(this.props.returnUrl);
    };

    render() {
        const props = this.props;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.Documents}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                <EditPageHeader
                    title={Translations.Documents + " - " + item.code}
                    onBackClick={this.handleBackClick}
                />
                <Footer
                    buttonClass="download mui"
                    buttonTitle={Translations.Download}
                    onClick={this.handleDownload}
                />
                <div className="pageContentContainer mainEdit documentView">
                    <div className="dataContainer">
                        <div className="row documentTitle">
                            <div className="col col-12">
                                <div className="iconCont">
                                    <AvatarImage
                                        name={item.modifyName}
                                        image={item.modifyPicture}
                                    />
                                </div>
                                <div className="dateCont ra">{Base.timeToDateStr(item.modifyDate)}</div>
                                <span className="dataCont">
                                    <label className="control-label">{item.code}</label>
                                    <div>{item.modifyName}</div>
                                </span>
                            </div>
                        </div>
                        <div className="row documenContent">
                            <div className="col col-12" dangerouslySetInnerHTML={ { __html: item.content } } />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}